import { useQuery } from '@tanstack/react-query';
import { isAdModule, isOdpModule } from '@utils/constants';
import getSPIThresholds from '@src/api/SPI';
import useKpiStore from '@globalStore/kpiStore';
import { trackQueryError } from '@src/utils/sensor/apptracker';

const hasKpi = !(isOdpModule || isAdModule);

const useThresholds = () => {
  const { setKPIs } = useKpiStore.getState();

  // Note: getSelectedKPI API call removed - we now use currentKpiAtom for per-dashboard KPI state
  // The selected KPI is managed via Jotai atoms and persisted in dashboard state

  const { isFetched: isKpiListFetched, isError: isKpiListError } = useQuery(
    ['kpi-list'],
    async () => {
      const resp = await getSPIThresholds({});
      const { kpiThresholds = [] } = resp || {};
      setKPIs(kpiThresholds);
      return resp;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: hasKpi,
      staleTime: Infinity,
      notifyOnChangeProps: ['isError', 'isFetched'],
      onError: (err) => {
        trackQueryError({ type: 'init-kpi', err });
      },
    },
  );

  return {
    isFetched: hasKpi ? isKpiListFetched : true, // isSelectedKpiFetched removed since query is disabled
    isError: isKpiListError, // isSelectedKpiError removed since query is disabled
  };
};

export default useThresholds;
